import React, { memo, useEffect, useState } from "react"
import styled from "@emotion/styled"
import { GatsbyImage } from "gatsby-plugin-image"

const StyledImage = styled(GatsbyImage)`
  width: 100%;

  ${({ ratio }) =>
    ratio
      ? `
		> div:first-of-type {
			padding-top: ${ratio * 100}% !important;
		}
		img {
			display: block;
		}
	`
      : ""}
  ${({ rounded }) =>
    rounded
      ? `
		overflow: hidden;
		border-radius: var(--card-border-radius);
		img {
			overflow: hidden;
			border-radius: var(--card-border-radius);
		}
	`
      : ""}
	img {
    ${({ isLinkCard }) =>
      isLinkCard &&
      `
			object-fit: scale-down !important;
			padding: 0 10px;
		`}
    ${({ hotspot }) =>
      hotspot
        ? `
			object-position: ${hotspot.x * 100 + "%"} ${hotspot.y * 100 + "%"};
		`
        : ""}
  }

  img[data-placeholder-image] {
    opacity: ${({ ready }) => (ready ? `0` : `1`)};
  }

  img[data-main-image] {
    ${({ ready }) => (ready ? `opacity: 1 !important; ` : ``)}
  }
`

const Image = memo(function Image({
  media,
  ratio = false,
  hotspot,
  crop,
  image,
  rounded,
  sizes,
  className,
  loading = "lazy",
  alt,
  width,
  height,
  isLinkCard,
  ...rest
}) {
  const [ready, setReady] = useState(false)
  const croppedWidth = image?.width * (1 - crop?.left - crop?.right)
  const croppedHeight = image?.height * (1 - crop?.top - crop?.bottom)
  const croppedRatio = croppedHeight / croppedWidth

  const rectTop = Math.round(crop?.top * height)
  const rectLeft = Math.round(crop?.left * width)
  const rectBottom = crop?.bottom * height
  const rectRight = crop?.right * width
  const rectWidth = Math.round(width - rectLeft - rectRight)
  const rectHeight = Math.round(height - rectTop - rectBottom)
  const rect = rectLeft + "," + rectTop + "," + rectWidth + "," + rectHeight

  useEffect(() => {
    if (width && height && crop) {
      const { src, srcSet } = image.images.fallback
      const rectReg = /rect=.*,\d{1,5}/g
      // Change src to use crop
      if (image.images.fallback.src.match(rectReg)) {
        image.images.fallback.src = src.replaceAll(rectReg, "&rect=" + rect)
      } else {
        image.images.fallback.src = src + "&rect=" + rect
      }
      // Change srcSet to use crop
      if (image.images.fallback.srcSet.match(rectReg)) {
        image.images.fallback.srcSet = srcSet.replaceAll(
          rectReg,
          "rect=" + rect
        )
      } else {
        image.images.fallback.srcSet = srcSet.replaceAll(
          "&auto=format",
          "&auto=format&rect=" + rect
        )
      }
    }
    setReady(true)
  }, [])

  return (
    <StyledImage
      isLinkCard={isLinkCard} // added to style only the link card images as they don't fit properly
      image={{ ...image, ...{ backgroundColor: "transparent" } }}
      ratio={ratio || croppedRatio}
      rounded={rounded}
      hotspot={hotspot}
      sizes={sizes}
      className={className}
      loading={loading}
      alt={alt || ""}
      format={["avif", "webp", "auto"]}
      ready={ready}
      style={{
        opacity: ready ? 1 : 0,
        transition: "opacity 200ms ease-in",
        transitionDelay: "100ms",
      }}
      {...rest}
    />
  )
})

export default Image
